import type { AndroidDraftConfig, CompressionQuality, IosDraftConfig, JsDraftConfig } from './types';

export const LOCKED_MANUAL_BADGES: string[] = ['email', 'password', 'telephone', 'text', 'textarea'];

export const SEARCH_EXTENSION = 'search';
export const ADVANCED_BULK_EXTENSIONS: string[] = [
  'color',
  'date',
  'datetime-local',
  'month',
  'number',
  'range',
  'select',
  'time',
  'url',
  'week',
] as string[];

export const OTHER_MASKING_TYPES: string[] = [SEARCH_EXTENSION, ...ADVANCED_BULK_EXTENSIONS];

export const COMPRESSION_QUALITY_OPTIONS: { label: string; value: CompressionQuality }[] = [
  { label: 'Low', value: 'low' },
  { label: 'Medium', value: 'medium' },
  { label: 'High', value: 'high' },
];

// Android masking types (from latest API contract)
export const ANDROID_MASK_INPUT_OPTIONS: string[] = ['dateTime', 'personName', 'postalAddress', 'url'];
export const ANDROID_DEFAULT_MASK_INPUT_OPTIONS: string[] = ['email', 'password', 'phoneNumber'];

// iOS masking types (from latest API contract)
export const IOS_MASK_INPUT_OPTIONS: string[] = [
  'addressCity',
  'addressCityAndState',
  'addressState',
  'familyName',
  'fullStreetAddress',
  'location',
  'middleName',
  'name',
  'namePrefix',
  'nameSuffix',
  'nickname',
  'organizationName',
  'postalCode',
  'streetAddressLine1',
  'streetAddressLine2',
  'username',
  'URL',
] as string[];

export const IOS_DEFAULT_MASK_INPUT_OPTIONS: string[] = [
  'creditCardNumber',
  'emailAddress',
  'newPassword',
  'oneTimeCode',
  'password',
  'telephoneNumber',
] as string[];

export const EMPTY_JS_CONFIG: JsDraftConfig = {
  enabled: false,
  samplingPct: 10,
  blockSelector: [],
  ignoreSelector: [],
  maskTextSelector: [],
  maskAllInputs: false,
  maskInputOptions: [],
  mousemove: false,
};

export const EMPTY_ANDROID_CONFIG: AndroidDraftConfig = {
  enabled: false,
  samplingPct: 10,
  maskAllInputs: false,
  maskInputOptions: [],
  maskAllImages: false,
  compressionQuality: 'low',
};

export const EMPTY_IOS_CONFIG: IosDraftConfig = {
  enabled: false,
  samplingPct: 10,
  maskAllInputs: false,
  maskInputOptions: [],
  maskAllImages: false,
  maskSandboxedSystemViews: false,
  compressionQuality: 'low',
};
